import { render } from "./TariffItem.vue?vue&type=template&id=f9e73882&scoped=true"
import script from "./TariffItem.vue?vue&type=script&lang=js"
export * from "./TariffItem.vue?vue&type=script&lang=js"

import "./TariffItem.vue?vue&type=style&index=0&id=f9e73882&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9e73882"]])

export default __exports__